module.exports = __webpack_public_path__ + "img/footer-logo.81db3615.png";